/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Offers\OffersStats\OfferTable\OfferTable.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 15th January 2024 01:37:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { memo, useMemo } from "react";
import { OfferRowUser } from "Content/Offers/OfferRowUserSingle/OfferRowUser";
import { OfferUserType } from "Type/offer.type";

type OfferListProps = {
    offer: OfferUserType[],
    displayName: boolean,
    order?: string
};

const OfferTableMemo = memo(function ConnexionList (props: OfferListProps) {
    const buildTableHeader = () => {
        let tableHeader = ["Car", "Client", "Commercial", "Date", "Value", "Gifted", "ByCommercial", "Sell"];
        return tableHeader.map(val =>
            <TableCell align="center" key={Math.random()}>{translator.decode(`table.headers.${val}`)}</TableCell>
        );
    };

    const buildRows = () => {
        const rows: JSX.Element[] = [];
        for (let i = 0; i < props.offer.length; ++i)
            rows.push(<OfferRowUser Offer={props.offer[i]} />);
        return rows;
    };

    const offerValues = useMemo(() => {
        return buildRows();
    }, [props.offer]);

    return (
        <Paper elevation={4}>
            <Table stickyHeader >
                <TableHead>
                    <TableRow>
                        { buildTableHeader() }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {offerValues}
                </TableBody>
            </Table>
        </Paper>
    )
});

export default OfferTableMemo;
